import { createNotificationsStore, type NotificationsStore } from "@/stores/notificationsStore";
import { useAdminAuthStore } from "@/stores/adminAuthStore";
import { getAdminSocket } from "@/lib/adminSocket";
import { onResync } from "@/lib/socketRecovery";
import { mocksEnabled } from "@/portals/physician/api/transport";
import {
  listAdminNotificationsApi,
  markAdminNotificationReadApi,
  markAllAdminNotificationsReadApi,
} from "@/portals/admin/api/adminNotificationsApi";

let store: NotificationsStore | null = null;

/**
 * The admin portal's own feed — admin socket, session and endpoints. Created on
 * first use (the admin header's bell), so patient/physician sessions never create
 * it or the admin socket.
 */
export const getAdminNotificationsStore = (): NotificationsStore => (store ??= createNotificationsStore({
  list: listAdminNotificationsApi,
  markRead: markAdminNotificationReadApi,
  markAllRead: markAllAdminNotificationsReadApi,
  onIncoming: (handler) => {
    if (!mocksEnabled()) getAdminSocket().on("notification:new", handler);
  },
  onTokenChange: (handler) => {
    // See physicianNotificationsStore: report the current token on the next
    // microtask, since this runs inside zustand's initializer.
    queueMicrotask(() => handler(useAdminAuthStore.getState().accessToken));
    useAdminAuthStore.subscribe((state) => handler(state.accessToken));
  },
  onResync: (handler) => {
    if (!mocksEnabled()) onResync(getAdminSocket(), handler);
  },
}));
